import React, { Component } from "react";
import { Modal } from "antd";
import { ajax, unparam, isValidBrowser } from "utils/common";
import VideoModel from "components/videoModel";
import "./index.less";
//图片
import Logo from "images/logo.png";
import startRecord from "images/start-record.png";
//欢迎页
import Welcome from "./webcome";
//答前须知
import Notice from "./notice";
//隐私政策
import Privacy from "./privacy";
//视频面试状态
import VideoStatus from "components/videoStatus";
// 国际化
import i18nZh_cn from "utils/zh_cn";
import i18nEn_us from "utils/en_us";

class App extends Component {
	
    // 开发账号
    developAccountId = ["11111", "22222", "33333"];

	state = {
		userInfo: {},
		paperInfo: {},
		accountId: "",
		finishStatus: -1,
		showNotice: false,
		questionIndex: 0,
		showModal: false,
		videoStatus: 0,
		checked: false,
		visible: false,
		corpLogo: "",
		showPrivacy: "1",	//1: 显示空页面，2：不显示隐私政策，3：显示隐私政策
		year: new Date().getFullYear(),
		lang: "zh_cn",
    	message: ''
	}

	componentDidMount() {
		// 展示logo
		// this.setState({
		// 	corpLogo: location.origin + "/oivi/account/getLogo",
		// })
		//获取页面参数
		const queryString = unparam(location.search);
        // 国际化
        const lang = queryString.lang ? queryString.lang.toLocaleLowerCase() : "zh_cn";
        const i18n = lang === "en_us" ? i18nEn_us : i18nZh_cn;
        this.setState({
        	accountId: queryString.accountId,
            i18n,
            lang
        }, () => {
        	//没有账号不允许打开页面
	        if (!queryString.accountId){
	            this.setState({
	                showModal: true,
	                videoStatus: 6
	            })
				return false;
	        }
			this.showIndex(queryString.accountId);
        })
	}
	//显示欢迎页
	showIndex = (accountId) => {
		const { i18n } = this.state;
		// 获取账号信息
  		ajax({
	      	url: "/account/getAccountById",
	      	data: {
	        	accountId: accountId,
                videoResource: 2
	      	}
	    }).then(async account => {
    		//账号信息
    		const userInfo = account.data || {};
			// 展示logo
			this.setState({
				corpLogo: `${location.origin}/oivi/account/logo/${userInfo.corpCode}.png`,
			})
            // AI面试跳转AI面试链接
            if(userInfo.aiStatus === 1 && location.pathname !== "/webai/AISubpackages/privacy/index"){
                window.location.replace(`/webai/AISubpackages/privacy/index?accountId=${accountId}&lang=${this.state.lang || "zh_cn"}`);
                return;
            }
			//暂不支持移动端提示
			const userAgent = window.navigator.userAgent;
			if(userAgent.indexOf("Mobile") >= 0 ){
				Modal.info({
                    className: 'report-modal-info',
		            title: i18n.showModal.title,
		            content: i18n.index.notSuportMobileText,
	            	okText: i18n.device.btnText,
		            onOk() {
						//关闭页面
						history.back();
			  			window.close();
		            }
				})
				return false;
			}
			//检测浏览器是否支持
			if(userAgent.indexOf("Trident") >= 0){
				Modal.info({
					title: i18n.showModal.title,
					content: i18n.index.browserNotSuportText,
					okText: i18n.device.btnText,
					onOk() {
						//关闭页面
						history.back();
						window.close();
					}
				})
				return false;
			} else {
				try {
					let TRTC = await import("trtc-js-sdk");
					try {
						let systemRequire = await TRTC.checkSystemRequirements();
						if(!systemRequire || !systemRequire?.result  || !isValidBrowser) {
							Modal.info({
								title: i18n.showModal.title,
								content: i18n.index.browserNotSuportText,
								okText: i18n.device.btnText,
								onOk() {
									//关闭页面
									history.back();
									window.close();
								}
							})
						} else {
							//存储公司名和候选人姓名
							localStorage.corpCode = userInfo.corpCode;
							localStorage.corpName = userInfo.corpName;
							localStorage.userName = userInfo.userName;
							// status：1 录制完毕，0 录制未完毕
							if (userInfo.status === 1) {
								// 判断完成状态，2:未开始已过期，3: 已开始已过期
								if(userInfo.submitStatus === 2 || userInfo.submitStatus === 3){
									this.setState({
										showModal: true,
										videoStatus: 2,
										userInfo: userInfo
									})
									return false;
								}
								const isEvaluate = userInfo.isEvaluate === 0?1:"";
								this.props.history.replace({
									pathname: "/suggest",
									search: "?accountId="+ accountId + "&evaluate=" + isEvaluate + "&lang=" + i18n.lang
								})
							} else {
								let canVisitsTimes = userInfo.canVisits || 3;
								// 从上次未答完的题开始录制
								if (userInfo.accessNum >= canVisitsTimes && !this.developAccountId.includes(accountId)) {
									// 可再进入次数已用完
									this.setState({
										showModal: true,
										videoStatus: 7,
										userInfo: userInfo
									})
								} else if(userInfo.accessNum > 0 && userInfo.accessNum < canVisitsTimes && !this.developAccountId.includes(accountId)) {
									// 继续上次的视频录制
									this.setState({
										showModal: true,
										videoStatus: 3,
										userInfo: userInfo
									})
								} else {
									this.showPrivacy(accountId);
									document.title = i18n.pageTitle.index;
									this.setState({
										finishStatus: userInfo.status,
										userInfo: userInfo
									})
								}
								//清除计时
								clearInterval(this.timer);
								//定时请求
								this.timer = setInterval(() => {
									ajax({
										url: "/sys/heartBeat",
									}).then(res => {})
								}, 30000);
							}
						}
					} catch(err) {
						console.log("TRTC checkSystemRequirements error: ", err)
					}
				} catch(err) {
					console.log("TRTC import error: ", err)
				}
			}
	    }).catch(err => {
			let userInfo = err.data || {};
            // AI面试跳转AI面试链接
            if(userInfo.aiStatus === 1 && location.pathname !== "/webai/AISubpackages/privacy/index"){
                window.location.replace(`/webai/AISubpackages/privacy/index?accountId=${accountId}&lang=${this.state.lang || "zh_cn"}`);
                return;
            }
			// 展示logo
			this.setState({
				corpLogo: `${location.origin}/oivi/account/logo/${userInfo.corpCode}.png`,
			})
	    	if(err.status == 502){		// 面试尚未开始
	    		this.setState({
					showModal: true,
					videoStatus: 1,
		    		userInfo: userInfo,
            		message: err.message || ''
				})
	    	}else if(err.status == 503){	// 已在其他设备上进行
	    		let canVisitsTimes = userInfo.canVisits || 3;
	    		if(userInfo.accessNum >= canVisitsTimes){
	    			this.setState({
						showModal: true,
						videoStatus: 7,
			    		userInfo: userInfo
					})
	    		}else{
			    	this.setState({
						showModal: true,
						videoStatus: 4,
			    		userInfo: userInfo
					})
	    		}
	    	}else if(err.status == 504){	// 账号无效
	    		this.setState({
					showModal: true,
					videoStatus: 10
				})
	    	}else if(err.status == 505){	// 设备锁定
	    		this.setState({
					showModal: true,
					videoStatus: 8,
		    		userInfo: userInfo
				})
	    	}else if(err.status == 506) {    // 进入次数已用完
	    		this.setState({
					showModal: true,
					videoStatus: 7,
		    		userInfo: userInfo
				})
	    	}else{
	    		this.setState({
		    		userInfo: userInfo
				})
		    	Modal.info({
		            title: i18n.showModal.title,
		            content: err.message,
	            	okText: i18n.device.btnText,
		            onOk() {
						//关闭页面
						history.back();
			  			window.close();
		            }
				})
	    	}
	    })
	}
	// 设备检测
	toCheck = () => {
		if(this.state.checked){
			this.props.history.replace({
				pathname: "/check",
				search: "?accountId="+ this.state.accountId + "&lang=" + this.state.lang
			})
		}else{
			const { i18n } = this.state;
			Modal.info({
	            title: i18n.showModal.title,
	            content: i18n.index.instructionsTips,
	            okText: i18n.device.btnText
	        })
		}
	}
	// 直接跳过
	toNext = () => {
		if(this.state.checked){
			this.setState({
				visible: true
			})
		}else{
			const { i18n } = this.state;
			Modal.info({
	            title: i18n.showModal.title,
	            content: i18n.index.instructionsTips,
	            okText: i18n.device.btnText
	        })
		}
	}
	// 打开答题须知
	toNotice = (index) => {
		this.setState({
			questionIndex: typeof index != "undefined" ? index : 0,
			showNotice: true
		})
	}
	// 关闭答题须知
	closeNotice = () => {
		this.setState({
			showNotice: false,
			checked: true
		})
	}
    //试录
    toTry = () => {
        this.props.history.replace({
            pathname: "/record",
            search: "?accountId="+ this.state.accountId +"&questionIndex=-1&showPosture=1&lang=" + this.state.lang
        })
    }
    //正式录制弹框按钮
    toRecordBtn = () => {
        this.toRecord();
    }
    //正式录制
	toRecord = () => {
		const { accountId, questionIndex, lang } = this.state;
		const showPosture = questionIndex > 0 ? "" : "1";
		this.props.history.replace({
			pathname: "/record",
			search: "?accountId="+ accountId +"&questionIndex=" + questionIndex + "&showPosture=" + showPosture + "&lang=" + lang
		})
	}
	//关闭弹窗
	hideModal = () => {
		if(this.state.videoStatus === 3){
			const userInfo = this.state.userInfo;
			if(userInfo.haveAnsweredNum > 0){
				this.setState({
					showModal: false,
		    		questionIndex: userInfo.haveAnsweredNum
		    	}, () => {
		    		this.toRecord();
		    	})
			}else{
				this.setState({
					showModal: false,
					visible: true
				})
			}
		}else{
			//关闭页面
			history.back();
  			window.close();
		}
	}

	handleChange = (e) => {
	    this.setState({
	      	checked: e.target.checked,
	    });
	}

	handleImgError = () => {
		this.setState({
			corpLogo: Logo
		})
	}

	//是否显示隐私政策
	showPrivacy = (accountId) => {
		//隐私政策
		const allPrivacyStatus = localStorage.privacyStatus?JSON.parse(localStorage.privacyStatus):{};
		this.setState({
			showPrivacy: allPrivacyStatus[accountId]?"2":"3"
		})
	}

	//同意隐私政策
	agreePrivacy = () => {
		//隐私政策
		const allPrivacyStatus = localStorage.privacyStatus?JSON.parse(localStorage.privacyStatus):{};
		allPrivacyStatus[this.state.accountId] = "1";
		localStorage.privacyStatus = JSON.stringify(allPrivacyStatus);
		this.setState({
			showPrivacy: "2"
		})
		this.showIndex(this.state.accountId);
	}

	//不同意隐私政策
	refusePrivacy = () => {
		this.setState({
			showPrivacy: "2"
		})
		//关闭页面
		history.back();
		window.close();
	}

    render() {
    	//用户信息
    	const {
    		corpLogo,
    		userInfo,
			finishStatus,
    		showNotice,
    		showModal,
    		videoStatus,
    		visible,
    		showPrivacy,
    		year,
    		i18n,
        	message
    	} = this.state;

    	// 国际化
        if(!i18n) return null;

		return(
			<div className="video-app-wrap video-background-wrap">
				{
					corpLogo &&
					<img className="video-logo" src={corpLogo} onError={this.handleImgError}/>
				}
				{
					showPrivacy === "1"?null:
					(
						showPrivacy === "3"?<Privacy handleAgree={this.agreePrivacy} handleRefuse={this.refusePrivacy} i18n={i18n} />:
						(
							(finishStatus === 0 || finishStatus === 2 || finishStatus === 6) ? (showNotice?
							<Notice userInfo={userInfo} closeNotice={this.closeNotice} i18n={i18n} />:
							<Welcome userInfo={userInfo}
								toNotice={this.toNotice}
								checked={this.state.checked}
								toCheck={this.toCheck}
								toNext={this.toNext}
							 	i18n={i18n}
								handleChange={this.handleChange} />) : null
						)
					)
				}
				<VideoModel title={i18n.showModal.titlePC} visible={showModal}>
	                <VideoStatus message={message} status={videoStatus} i18n={i18n} userInfo={userInfo} hideModal={this.hideModal} />
	            </VideoModel>
                <VideoModel visible={visible} title={i18n.startInterviewModal.title}>
                    <div className="model-record-wrap">
                        <img className="model-record-img" src={startRecord} />
                        <p className="model-record-content">{i18n.startInterviewModal.content1}</p>
                        <p className="model-record-content">{i18n.startInterviewModal.content2}</p>
                        <div className="model-record-btns">
                            <div className="model-record-btn model-btn-fill" onClick={this.toTry}>{i18n.startInterviewModal.cancelText}</div>
                            <div className="model-record-btn model-btn-blank" onClick={this.toRecordBtn}>{i18n.startInterviewModal.okText}</div>
                        </div>
                    </div>
                </VideoModel>
				<p className="video-index-copyright">{i18n.copyright1 + year + i18n.copyright2}</p>
			</div>
		)
    }
}

export default App;
